//* Import react and other libraries
import React from "react";

//* Import components from react-bootstrap
import { Container, Row, Col } from "react-bootstrap";

//* Import icons from lucide-react
import { Briefcase, Users, User, UserCheck } from "lucide-react";

//* Import types from types
import { type UnitDetails } from "../../../../hooks/units/types/types";

//*type for the structure
type UnitHeaderProps = {
  unitDetails: UnitDetails;
};

export const UnitHeader: React.FC<UnitHeaderProps> = React.memo(
  ({ unitDetails }) => {
    return (
      <div className="bg-light py-4 border-bottom">
        <Container>
          <Row className="align-items-center">
            <Col md={8}>
              <h2 className="mb-1 text-dark">{unitDetails.name}</h2>
              <p className="text-muted mb-0">
                {unitDetails.description || "Sem descrição disponível."}
              </p>
            </Col>
            <Col md={4} className="text-md-end mt-3 mt-md-0">
              <div className="d-flex justify-content-md-end align-items-center mb-2">
                <Briefcase
                  className="me-2 text-primary"
                  size={20}
                  aria-hidden="true"
                />
                <span className="text-dark">
                  <strong>Organização:</strong> {unitDetails.organization.name}
                </span>
              </div>
              <div className="d-flex justify-content-md-end align-items-center">
                <Users
                  className="me-2 text-primary"
                  size={20}
                  aria-hidden="true"
                />
                <span className="text-dark">
                  <strong>Total de Equipes:</strong>{" "}
                  {unitDetails.totalTeams || 0}
                </span>
              </div>
              <div className="d-flex justify-content-md-end align-items-center mt-1">
                <User
                  className="me-2 text-primary"
                  size={20}
                  aria-hidden="true"
                />
                <span className="text-dark">
                  <strong>Total de Alunos:</strong>{" "}
                  {unitDetails.totalStudents || 0}
                </span>
              </div>
              <div className="d-flex justify-content-md-end align-items-center mt-1">
                <UserCheck
                  className="me-2 text-primary"
                  size={20}
                  aria-hidden="true"
                />
                <span className="text-dark">
                  <strong>Alunos Ativos:</strong>{" "}
                  {unitDetails.totalActiveStudents || 0}
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
);
